import * as Yup from 'yup';
import type {Dayjs} from 'dayjs';
import dayjs from '../services/customDayJs';
import i18n from '../services/i18n';

export const notPastDateTest = (
    messageKey: string,
    getToday: (context: Yup.TestContext) => Dayjs,
    getMessageValue: (value: string, context: Yup.TestContext) => string,
): Yup.TestFunction<string | null | undefined> =>
    function (value, context) {
        if (!value) {
            return true;
        }

        const date = dayjs(value, 'YYYY-MM-DD').startOf('date');
        const today = getToday(context).startOf('date');

        return !date.isBefore(today)
            ? true
            : context.createError({
                message: i18n.t<string>(messageKey, {value: getMessageValue(value, context)}),
            });
    };
